module.exports = __webpack_public_path__ + "static/flooring-8f070e1667b5262ce1ea42c233222818.jpg";